import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
    DEACTIVATE_FLANGE_JOINT_CONNECTION_STARTING,
    DEACTIVATE_FLANGE_JOINT_CONNECTION_SUCCESS,
    DEACTIVATE_FLANGE_JOINT_CONNECTION_ERROR,
} from '../../../constants/actionTypes';

export default function deactivateFlangeJointReducer(state = initialState.deactivateFlangeJoint, action) {
    switch (action.type) {
        case DEACTIVATE_FLANGE_JOINT_CONNECTION_STARTING: {
            const { flangeJointId } = action;
            const newState = clone(state);

            if (!newState[flangeJointId]) {
                newState[flangeJointId] = clone(initialState.deactivateFlangeJoint.flangeJointId);
            }

            const flangeJointData = newState[flangeJointId];
            flangeJointData.saving = true;
            flangeJointData.saved = false;
            flangeJointData.error = null;

            return newState;
        }

        case DEACTIVATE_FLANGE_JOINT_CONNECTION_SUCCESS: {
            const { flangeJointId } = action;
            const newState = clone(state);

            if (!newState[flangeJointId]) {
                newState[flangeJointId] = clone(initialState.deactivateFlangeJoint.flangeJointId);
            }

            const flangeJointData = newState[flangeJointId];
            flangeJointData.saving = false;
            flangeJointData.saved = true;
            flangeJointData.error = null;
            return newState;
        }

        case DEACTIVATE_FLANGE_JOINT_CONNECTION_ERROR: {
            const { flangeJointId } = action;
            const newState = clone(state);

            if (!newState[flangeJointId]) {
                newState[flangeJointId] = clone(initialState.deactivateFlangeJoint.flangeJointId);
            }

            const flangeJointData = newState[flangeJointId];
            flangeJointData.saving = false;
            flangeJointData.saved = false;
            flangeJointData.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}
